import { Apollo } from 'apollo-angular';
import { PersistenceScope } from './persistence-scope';
import { StateService } from './state-service';
import { StateVar } from './state-var';
import * as fromGraphQl from './graphql';

export class ComponentState<T> {
  private key: string;
  private stateVars = new Array<StateVar<any>>();
  private currentState = {} as T;
  private callback: (test: T) => any;
  private initialized = false;
  private stateService: StateService;

  constructor(key: string, stateService: StateService, private apollo: Apollo) {
    this.key = key;
    this.stateService = stateService;
  }

  addStateVar(stateVar: StateVar<any>) {
    this.stateVars.push(stateVar);
  }

  update(stateVar: StateVar<any>, newValue: any) {
    // console.log("Update " + this.key + "." + stateVar.key + " with new value: " + newValue);
    this.stateService.updateValue(this.key, stateVar, newValue);
    this.currentState[stateVar.key as keyof T] = newValue;
    this.callback(this.currentState);
  }

  watch(callback: (test: T) => any) {
    // set the callback function that should be called
    // after state has changed
    this.callback = callback;
    // do some init work
    if (!this.initialized) {
      this.stateService.updateKeys(this.key, this.stateVars);
      // console.log('Initialize state.');
      // lets find the value for each state var
      this.stateVars.map((stateVar) => {
        // console.log('Initialize stateVar ' +stateVar.key +' with initial value: ' +stateVar.initialValue);
        this.currentState[stateVar.key as keyof T] = this.stateService.getValue(
          this.key,
          stateVar
        );
        // console.log('Actual value: ' + this.currentState[stateVar.key as keyof T]);
        if (stateVar.persistenceScope == PersistenceScope.Backend) {
          this.subscribeToUserSettingsData(
            this.key + '.' + stateVar.key,
            stateVar
          );
        }
      });
      // call the callback function to tell the component about the state
      this.callback(this.currentState);
      this.initialized = true;
    }
  }

  private subscribeToUserSettingsData(key: string, stateVar: any) {
    this.apollo
      .watchQuery<fromGraphQl.UserSettingsQueryResponse>({
        pollInterval: 10000,
        fetchPolicy: 'no-cache',
        query: fromGraphQl.USER_SETTINGS_QUERY,
        notifyOnNetworkStatusChange: true,
      })
      .valueChanges.subscribe((result: any) => {
        // console.log('current response in polling', result);
        if (result?.data?.currentUserSettings?.frontend_web) {
          const response = JSON.parse(
            result.data.currentUserSettings.frontend_web
          );
          if (response[key]) {
            this.currentState[stateVar.key as keyof T] = response[key];
          }
          stateVar.currentValue = response[key];
        }
        this.callback(this.currentState);
      });
  }
}
